<template>
  <div>
    <b-table striped small fixed responsive="sm" caption-top :items="items" :fields="fields">
      <template slot="table-caption">{{device? device.model: 'INVALID DEVICE'}} ({{device? device.id: id }})</template>
      <template slot="value" slot-scope="data">
        <strong>{{data.item.value | beautify}}</strong>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'Device',
  props: {
    id: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      default: 'Device id'
    },
  },
  data: function() {
    return {
      device: null,
      fields: [
        {key: 'key'},
        {key: 'value'},
      ],
    }
  },
  created: function() {
    console.debug('created : ', this.id)
    if (!this.id) {
      console.error("id required")
      return
    }

    const deviceId = this.id.split('/').filter( s => !!s).pop() //get last element
    console.info('deviceId: ', deviceId)
    this.$bind('device', this.$firebase.firestore().collection('devices').doc(deviceId))
  },  
  computed: {
    items() {
      const deviceDetails = this.device ? Object.entries(this.device) : [['id', 'Not found']]
      return deviceDetails.filter(([key, value]) => {
        return key !== 'ownedBy';
      })
      .map(([key, value]) => {
        return {key: key, value: value}
      })
    },
  },
  mounted: function() {

  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>
